import React from 'react'

function CallToAction() {
  return (
    <div>


        
<div className="container">
    <section className="cta-section call-to-action-radius  text-center text-white py-5"
    style={{ 
      background: "linear-gradient(135deg, #1e3c72, #2a5298)", 
      margin: "60px 0"
    }}>
  <div className="container">
    <h2 className="fw-bold mb-3 text-white">Ready to Transform Your Business?</h2>
    <p className="mb-4 text-white">
      Partner with Faxian IT for innovative solutions that bring growth, 
      efficiency, and long-term success.
    </p>
    <a href="/contact" 
       className="btn fw-bold px-4 py-2"
       style={{ 
         backgroundColor: "#ffffff", 
         color: "#1e3c72", 
         borderRadius: "8px" 
       }}>
      Get a Free Consultation →
    </a>
  </div>
</section>

</div>

      
    </div>
  )
}

export default CallToAction
